import { render, staticRenderFns } from "./ATextClipboardField.vue?vue&type=template&id=40205898&"
import script from "./ATextClipboardField.vue?vue&type=script&lang=js&"
export * from "./ATextClipboardField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports